<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Course block')"></breadcrumbs>
      </div>
    </base-header>
    <v-wait :for="waiterKeyword">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">
            <div class="card bg-transparent">
              Student block info
            </div>
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<script>
  import Breadcrumbs from "../../Layout/Breadcrumbs.vue";
  import Spinner from 'vue-spinner-component/src/Spinner.vue';
  import {createNamespacedHelpers} from 'vuex';

  const {mapGetters, mapActions} = createNamespacedHelpers('course/block');

  export default {
    name: "CourseBlock",
    metaInfo() {
      return {
        title: "Course block",
        htmlAttrs: {
          lang: 'ru'
        }
      }
    },
    data() {
      return {
        orderingChanged: false,
        waiterKeyword: 'course block fetching'
      }
    },
    components: {
      Breadcrumbs,
      Spinner
    },
    created() {
      this.fetchData();
    },
    computed: {
      ...mapGetters({
        getBlock: 'getCurrentBlock',
      }),
    },
    watch: {
      '$route': 'fetchData',
    },
    methods: {
      ...mapActions({
        loadBlock: 'loadBlock',
      }),

      async fetchData() {
        this.$wait.start(this.waiterKeyword);
        await this.loadBlock({urlParams: this.$route.params});
        this.$wait.end(this.waiterKeyword);
      },

      isEmptyList(list) {
        return Array.isArray(list) && list.length === 0;
      },
    },
  };

</script>

<style scoped>

</style>
